export type TSrc = {
  lang: string;
  text: string;
};

export type TDst = TSrc;

export const SegmentStatus = {
  Done: 'done',
  Error: 'error',
  Processing: 'processing',
  Updated: 'updated',
} as const;

export type TSegmentStatus = (typeof SegmentStatus)[keyof typeof SegmentStatus];

export type TServerSegment = {
  id: string;
  dst: TDst;
  end: string;
  speaker: string;
  src: TSrc;
  start: string;
  status: TSegmentStatus;
};

export type TExtendedSegment = {
  isEditingSrc?: boolean;
  isMerging?: boolean;
  isRewriting?: boolean;
  isSavingError?: boolean;
  overlappedTimestamps?: (TServerSegment['end'] | TServerSegment['start'])[];
  rewritingResult?: string;
} & TServerSegment;

export type TAutoSavingSegmentData = {
  dst?: TExtendedSegment['dst'];
  end?: TExtendedSegment['end'];
  speaker?: TExtendedSegment['speaker'];
  start?: TExtendedSegment['start'];
};

export type TUpdatingSegmentData = ({ speaker: TExtendedSegment['speaker']; src: TExtendedSegment['src'] } | TAutoSavingSegmentData) &
  Pick<TExtendedSegment, 'id'>;

export type ParsedSrt = {
  id: string;
  endSeconds: number;
  endTime: string;
  speakerId: null | string;
  startSeconds: number;
  startTime: string;
  text: string;
};

export const SegmentLocation = {
  Bottom: 'bottom',
  Top: 'top',
} as const;

export type TSplittingSegmentData = {
  dst?: TServerSegment['dst'];
  src?: TServerSegment['src'];
} & Pick<TServerSegment, 'end' | 'start'>;
export type TSegmentLocation = (typeof SegmentLocation)[keyof typeof SegmentLocation];
